import { COLA_STATUS, FIELD } from './colaEnums';
export default function processField(fieldName, colaAnswer, msg) {
  var status = colaAnswer.status,
      processedField = colaAnswer.processedField;
  var field = processedField;

  switch (fieldName) {
    case FIELD.NEXT_PAYMENT_AMOUNT:
    case FIELD.NEXT_PAYMENT_DATE:
    case FIELD.DUE_DATE:
    case FIELD.PAY_NOW_AMOUNT:
    case FIELD.CLIENT_NUMBER:
    case FIELD.PENALTY_AMOUNT:
      {
        if (typeof processedField === 'string' && !processedField) {
          field = msg('chatBot.colaFields.paymentInfoNull');
        }

        break;
      }

    case FIELD.OVERDUE_DAYS:
      {
        if (!processedField && processedField !== 0) {
          field = msg('chatBot.colaFields.paymentInfoNull');
        }

        break;
      }

    case FIELD.EXTENSION_AMOUNT_7:
      {
        if (!processedField && status === COLA_STATUS.ERROR) {
          field = msg('chatBot.colaFields.loanExtensionAmountNull');
        }

        break;
      }

    case FIELD.CLIENT_APP_RESOLUTION_MESSAGE:
      {
        var fieldType = colaAnswer.fieldType;

        if (!processedField) {
          field = msg('chatBot.colaFields.clientAppResolutionMessageNull');
        } else {
          var pathToMap = 'chatBot';

          if (fieldType === 'resolutionDetail') {
            pathToMap += '.resolutionDetailMapping';
          } else if (fieldType === 'resolutionMessage') {
            pathToMap += '.resolutionMessageMapping';
          } else {
            pathToMap += '.resolution';
          }

          var parsedField = processedField.replace(/[^a-zA-Z0-9\s\_]/g, ''); // eslint-disable-line no-useless-escape
          // We need to parse constants and remove special characters,
          // Because translation server saving translations in yaml format.

          var strippedField = parsedField.includes(' ') ? parsedField.split(' ').join('_') : parsedField;
          pathToMap += ".".concat(strippedField);
          field = msg(pathToMap) || msg('chatBot.resolution.DEFAULT');
        }

        break;
      }

    case FIELD.LATEST_PAYMENT_DATE_ZP:
    case FIELD.LATEST_PAYMENT_DATE:
      {
        if (!processedField) {
          field = msg('chatBot.colaFields.latestPaymentDateNull');
        }

        break;
      }

    case FIELD.LOAN_NUMBER:
      {
        if (!processedField) {
          field = msg('chatBot.colaFields.loanNumberNull');
        }

        break;
      }

    case FIELD.BANK_ACCOUNT:
      {
        if (!processedField) {
          field = msg('chatBot.colaFields.bankAccountNull');
        }

        break;
      }

    case FIELD.DISCOUNT_TYPE:
      {
        var percentage = colaAnswer.percentage;

        if (!processedField) {
          field = msg('chatBot.colaFields.discountPercentageNull');
        } else {
          field = "".concat(msg("chatBot.colaFields.".concat(processedField)), " ").concat(percentage, "%");
        }

        break;
      }

    case FIELD.LATEST_PAYMENT_AMOUNT_ZP:
    case FIELD.LATEST_PAYMENT_AMOUNT:
      {
        if (!processedField) {
          field = msg('chatBot.colaFields.latestPaymentAmountNull');
        }

        break;
      }

    case FIELD.EXTENSION_AMOUNT_14:
      {
        if (!processedField && status === COLA_STATUS.ERROR) {
          field = msg('chatBot.colaFields.loanExtensionAmount14Null');
        }

        break;
      }

    case FIELD.EXTENSION_AMOUNT_30:
      {
        if (!processedField && status === COLA_STATUS.ERROR) {
          field = msg('chatBot.colaFields.loanExtensionAmount30Null');
        }

        break;
      }
  }

  return field;
}